import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './VerificationLoaderModal.css';
import cs from '../../components/commonStyle.css';
import { Modal, Button, Spinner } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import messages from '../../locale/messages';
import scanning_qr from '../../../public/siteImages/scanningQrCode.jpg';

class VerificationLoaderModal extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
    };

    render() {
        const { onClose, show } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={show} animation={false} onHide={onClose} className="verificationModal">
                <div className={cx(s.sectionBlock)}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className={cx(s.verificationContent, cs.textAlignCenter)}>
                            <img src={scanning_qr} alt="Scanning QR" />
                            <div className={s.loaderContainer}>
                                <div className={s.loader}><div className={s.loaderBar}></div></div>
                            </div>
                            <h2 className={cx(s.titleText)}>Waiting for Mobile Verification...</h2>
                            <p className={cx(s.contentText)}>We’ve detected your QR code scan. Complete the verification on your phone to continue. This may take a few seconds. Once verified, you’ll be redirected automatically.</p>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        );
    }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(VerificationLoaderModal))); 